export function tryCatch(f: Function) {
    try {
        return f();
    } catch (e) {
        console.error(e);
    }
}